import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ParametrosFacade } from '@vip/state/parametros';
import { ClienteTokenService } from '@vip/state/cliente';
import { LayoutUtilsService } from '@vip/core';

@Injectable()
export class ExigeAutenticacaoGuard implements CanActivate {
  constructor(
    private clienteTokenService: ClienteTokenService,
    private parametrosFacade: ParametrosFacade,
    private router: Router,
    private layoutUtilsService: LayoutUtilsService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    const isCarrinhoMobile =
      route?.routeConfig?.path === 'carrinho' &&
      !this.layoutUtilsService.isDesktop();

    if (this.clienteTokenService.getToken()) {
      return of(true);
    } else {
      if (isCarrinhoMobile) {
        this.router.navigate(['/login'], {
          queryParams: { redirectTo: state.url },
        });
        return of(false);
      }

      return this.parametrosFacade.exigeAutenticacao$.pipe(
        map((exigeAutenticacao) => {
          if (exigeAutenticacao) {
            this.router.navigate(['/login'], {
              queryParams: { redirectTo: state.url },
            });
          }
          return !exigeAutenticacao;
        }),
      );
    }
  }
}
